// Generated by BUCKLESCRIPT VERSION 1.9.1, PLEASE EDIT WITH CARE
'use strict';

var Block            = require("bs-platform/lib/js/block.js");
var Curry            = require("bs-platform/lib/js/curry.js");
var React            = require("react");
var Github           = require("./github");
var Header           = require("./header");
var ReasonReact      = require("reason-react/lib/js/src/reasonReact.js");
var Notifications    = require("./notifications");
var NotificationList = require("./notificationList");

((require('./app.css')));

var githubToken = ( localStorage.getItem("githubToken") );

var component = ReasonReact.reducerComponent("App");

function make() {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      var loadNotifications = function (token) {
        Notifications.fetchNotifications(token).then((function (response) {
                return Promise.resolve(Curry._2(self[/* reduce */3], (function () {
                                  return /* LoadNotifications */Block.__(0, [response.filter((function (n) {
                                                    return n[/* unread */1];
                                                  }))]);
                                }), /* () */0));
              }));
        return /* () */0;
      };
      var match = Github.getLocalToken(/* () */0);
      if (match) {
        var token = match[0];
        Curry._2(self[/* reduce */3], (function () {
                return /* Login */Block.__(2, [token]);
              }), /* () */0);
        loadNotifications(token);
      } else {
        var match$1 = Github.getCodeFromUrl(/* () */0);
        if (match$1) {
          Github.requestToken(match$1[0]).then((function (token) {
                  Curry._2(self[/* reduce */3], (function () {
                          return /* Login */Block.__(2, [token]);
                        }), /* () */0);
                  Curry._1(Github.setLocalToken, token);
                  return Promise.resolve(loadNotifications(token));
                }));
        }
        
      }
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var match = self[/* state */4][/* token */0];
      var loggedIn = match ? /* true */1 : /* false */0;
      var logout = function (e) {
        return Curry._2(self[/* reduce */3], (function (e) {
                      e.preventDefault();
                      Curry._1(Github.deleteLocalToken, /* () */0);
                      return /* Logout */0;
                    }), e);
      };
      var deleteNotification = function (n) {
        Notifications.markAsRead(githubToken, n).then((function (success) {
                if (success !== 0) {
                  Curry._2(self[/* reduce */3], (function () {
                          return /* DeleteNotification */Block.__(1, [n]);
                        }), /* () */0);
                } else {
                  console.log("Could not delete notification " + n[/* id */0]);
                }
                return Promise.resolve(/* () */0);
              }));
        return /* () */0;
      };
      var match$1 = self[/* state */4][/* notifications */1];
      var notificationList = match$1 ? ReasonReact.element(/* None */0, /* None */0, NotificationList.make(match$1[0], deleteNotification, /* array */[])) : (
          loggedIn !== 0 ? React.createElement("div", {
                  className: "mw6 center tc mv3"
                }, React.createElement("h2", {
                      className: "f5 f4-m f3-l fw2 black-50 mt0 lh-copy"
                    }, "Loading...")) : React.createElement("div", {
                  className: "mw6 center tc mv3"
                }, React.createElement("h2", {
                      className: "f5 f4-m f3-l fw2 black-50 mt0 lh-copy"
                    }, "Log in to see notifications."))
        );
      return React.createElement("div", {
                  className: "App"
                }, ReasonReact.element(/* None */0, /* None */0, Header.make(loggedIn, logout, /* array */[])), notificationList);
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* token : None */0,
              /* notifications : None */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        return /* Update */Block.__(0, [/* record */[
                    /* token : None */0,
                    /* notifications : None */0
                  ]]);
      } else {
        switch (action.tag | 0) {
          case 0 : 
              return /* Update */Block.__(0, [/* record */[
                          /* token */state[/* token */0],
                          /* notifications : Some */[action[0]]
                        ]]);
          case 1 : 
              var notification = action[0];
              var match = state[/* notifications */1];
              if (match) {
                return /* Update */Block.__(0, [/* record */[
                            /* token */state[/* token */0],
                            /* notifications : Some */[match[0].filter((function (n) {
                                      return +(n[/* id */0] !== notification[/* id */0]);
                                    }))]
                          ]]);
              } else {
                return /* NoUpdate */0;
              }
          case 2 : 
              return /* Update */Block.__(0, [/* record */[
                          /* token : Some */[action[0]],
                          /* notifications */state[/* notifications */1]
                        ]]);
          
        }
      }
    });
  return newrecord;
}

exports.githubToken = githubToken;
exports.component   = component;
exports.make        = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/app.re
// module id = 99
// module chunks = 0